import { FC } from "react"
import styled from "styled-components"

interface Props {
  title: string
  rating: number
  values: [string, string, string]
}

export const ProductRating: FC<Props> = ({ title, rating, values }) => {
  return (
    <StyledProductRating>
      <Title>{title}</Title>
      <Rating>
        <RatingBar>
          <Bar />
          {[...Array(5)].map((x, i) => {
            return <Dot key={i} $isActive={rating === i + 1} />
          })}
        </RatingBar>
        <Values>
          {values.map(val => {
            return <span key={val}>{val}</span>
          })}
        </Values>
      </Rating>
    </StyledProductRating>
  )
}

const StyledProductRating = styled.div`
  padding: 0 0 2.3rem;

  &:last-of-type {
    padding: 0 0 1.3rem;
  }
`

const Title = styled.span`
  margin: 0 0 0.6rem;
  font-size: 1rem;
  line-height: 2.4rem;
  letter-spacing: 1.67px;
  text-transform: uppercase;
`

const Rating = styled.div``

const RatingBar = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.5rem;
`

const Bar = styled.div`
  z-index: -1;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 2px;
  background: ${({ theme }) => theme.color.greyLight};
`

interface DotProps {
  $isActive: boolean
}

const Dot = styled.div<DotProps>`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.color.black : theme.color.greyLight};
`

const Values = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  line-height: 2.4rem;
  letter-spacing: 1.67px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.grey};
`
